module.exports = __webpack_public_path__ + "img/logo.185e4f83.png";